import { ADD_LIFE_COLLECTIONS, LOADING_SCREEN_HIDE, LOADING_SCREEN_SHOW, MODAL_SHOW, MODAL_TYPE_ERROR, REMOVE_LIFE_NEW_BENEFICIARY, SET_ACTIVE_LIFE_POLICY,SET_COLLECTION_TO_SCHEDULE, SET_LIFE_ACTIVE_BENEFICIARY_ID, SET_LIFE_ACTIVE_BENEFIT_ID, SET_LIFE_BANKING_DETAILS, SET_LIFE_COLLECTIONS, SET_LIFE_COLLECTIONS_LOADING, SET_LIFE_ENTITY_METADATA, SET_LIFE_NEW_BENEFICIARY, SET_LIFE_POLICY,SET_LIFE_POLICY_DEBIT_DAY,SET_LIFE_POLICY_DEBIT_DAY_FRIENDLY, SET_LIFE_POLICY_DETAILS, SET_LIFE_SPECIAL_DEBIT_DAYS, UPDATE_LIFE_BENEFICIARY, UPDATE_LIFE_CONTACT, UPDATE_LIFE_ENTITY_METADATA, UPDATE_LIFE_POLICY_BENEFITS, UPDATE_LIFE_PREMIUM_PAYER } from "../constants/constants";
import { ERROR_HEADER, ERROR_SOMETHING_WENT_WRONG } from "../constants/copy";
import { logErrorToDatabase, postToController } from "./apiActions";
import { hideModal, showRemoveLifeBeneficiaryModal } from "./modalActions";

export const setActiveLifePolicyId = (id: string) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_ACTIVE_LIFE_POLICY,
            payload: id
        });
    }
}

export const getLifePolicyDetails = (id: string, showLoadingScreen = true) => {
    return async (dispatch, getState) => {
        try {
            if (showLoadingScreen) {
                dispatch({ type: LOADING_SCREEN_SHOW });
            }
            
            const lifePolicyDetailsResponse = await postToController(dispatch, '/livin/GetPolicyDetails', null);

            if (showLoadingScreen) {
                dispatch({ type: LOADING_SCREEN_HIDE });
            }

            if (lifePolicyDetailsResponse && lifePolicyDetailsResponse !== 'Failure') {
                dispatch({
                    type: SET_LIFE_POLICY_DETAILS,
                    payload: lifePolicyDetailsResponse,
                });
            }
        } catch (err) {
            logErrorToDatabase("Error getLifePolicyDetails, Error: " + err);
        }
    }
}

export const submitScheduleSpecialDebit = (date: string) => {
    return async (dispatch, getState) => {
        dispatch({ type: LOADING_SCREEN_SHOW });

        const id = getState().lifePolicy.collectionToSchedule.id;

        try {
            await postToController(dispatch, '/livin/ScheduleSpecialDebit', JSON.stringify({
                date,
                id,
            }));
        } finally {
            dispatch({ type: LOADING_SCREEN_HIDE });
        }
    }
}

export const clearMetadata = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_LIFE_ENTITY_METADATA,
            payload: { },
        });
    }
}

export const updateDebitOrderDate = (date: any, text: any) => {
    return async (dispatch, getState) => {
        
        dispatch({ type: LOADING_SCREEN_SHOW });
        
        try {
            await postToController(dispatch, '/livin/UpdatePolicyDebitDay', JSON.stringify({
                debitOrderDueDate: date
            }));
            
            dispatch({
                type: SET_LIFE_POLICY_DEBIT_DAY,
                payload: date
            });
            
            dispatch({
                type: SET_LIFE_POLICY_DEBIT_DAY_FRIENDLY,
                payload: text
            });
            
            dispatch(getLifeBankingDetails());
            
        } catch (err) {
            logErrorToDatabase("Error updateDebitOrderDate, Error: " + err);
            throw err;
        } finally {
            dispatch({ type: LOADING_SCREEN_HIDE });
        }
    }
}

export const setLifeActiveBenefitId = (id: string) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_LIFE_ACTIVE_BENEFIT_ID,
            payload: id,
        });
    }
}

export const setLifeActiveBeneficiaryId = (id: string) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_LIFE_ACTIVE_BENEFICIARY_ID,
            payload: id,
        })
    }
}

export const removeLifeBeneficiary = (id: any) => {
    return async (dispatch, getState) => {

        dispatch(hideModal());
        
        dispatch({ type: LOADING_SCREEN_SHOW });
        
        const activeBenefitId = getState().lifePolicy.policy.activeBenefitId;
        const benefits = getState().lifePolicy.policy.benefits.reduce((benefits, benefit) => {
            if (benefit.id === activeBenefitId) {
                const beneficiaries = benefit.beneficiaries.reduce((beneficiaries, beneficiary) => {
                   if (beneficiary.id !== id) {
                       return [
                           ...beneficiaries,
                           beneficiary
                       ];
                   } else {
                       return [
                           ...beneficiaries
                       ]
                   }
                }, []);
                return [
                    ...benefits,
                    {
                        ...benefit,
                        beneficiaries
                    }
                ]
            } else {
                return [
                    ...benefits,
                    benefit
                ]
            }
        }, []);
        
        const benefit = benefits.filter((benefit) => benefit.id === activeBenefitId)[0];
        try {
            await postToController(dispatch, '/livin/removeBeneficiaries', JSON.stringify({
                beneficiaries: benefit.beneficiaries,
                benefitId: benefit.id,
            }));
        } finally {
            dispatch({ type: LOADING_SCREEN_HIDE });
        }


        dispatch({
            type: UPDATE_LIFE_POLICY_BENEFITS,
            payload: benefits,
        })
    }
}

export const removeLifeBeneficiaryModal = (id: any, cbFunc: () => any) => {
    return async (dispatch, getState) => {

        const activeBenefitId = getState().lifePolicy.policy.activeBenefitId;
        const benefit = getState().lifePolicy.policy.benefits.filter((benefit) => benefit.id === activeBenefitId)[0];
        const beneficiary = benefit.beneficiaries.filter((beneficiary) => beneficiary.id === id)[0];

        dispatch(showRemoveLifeBeneficiaryModal(beneficiary, cbFunc));
    }
}

export const setNewLifeBeneficiary = (beneficiary: any) => {
    return async (dispatch, getState) => {
        const newBeneficiaryPercentage = 5;
        const activeBenefitId = getState().lifePolicy.policy.activeBenefitId;
        const benefits = getState().lifePolicy.policy.benefits.reduce((benefits, benefit) => {
            if (benefit.id === activeBenefitId) {
                const beneficiaries = benefit.beneficiaries.reduce((beneficiaries, b, idx) => {

                    if (idx == 0) {
                        return [
                            ...beneficiaries,
                            {
                                ...b,
                                percentage: b.percentage - newBeneficiaryPercentage,
                            }
                        ];
                    } else {
                        return [
                            ...beneficiaries,
                            b
                        ];
                    }
                }, []);
                beneficiaries.push(beneficiary);
                return [
                    ...benefits,
                    {
                        ...benefit,
                        beneficiaries
                    }
                ]
            } else {
                return [
                    ...benefits,
                    benefit
                ]
            }
        }, []);

        dispatch({
            type: UPDATE_LIFE_POLICY_BENEFITS,
            payload: benefits
        });

        //dispatch({
        //    type: SET_LIFE_NEW_BENEFICIARY,
        //    payload: beneficiary
        //});
    }
}

export const removeNewBeneficiary = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: REMOVE_LIFE_NEW_BENEFICIARY,
            payload: null,
        });
    }
}

export const saveBeneficiary = (beneficiaryToSave: any) => {
    return async (dispatch, getState) => {
        
        dispatch({ type: LOADING_SCREEN_SHOW });
        
        const activeBenefitId = getState().lifePolicy.policy.activeBenefitId;
        const benefits = getState().lifePolicy.policy.benefits.reduce((benefits, benefit) => {
            if (benefit.id === activeBenefitId) {
                const beneficiaries = benefit.beneficiaries.reduce((beneficiaries, beneficiary) => {
                   if (beneficiaryToSave.id === beneficiary.id) {
                       return [
                           ...beneficiaries,
                           {
                               ...beneficiary,
                               ...beneficiaryToSave
                           }
                       ];
                   } else {
                       return [
                           ...beneficiaries,
                           beneficiary
                       ]
                   }
                }, []);
                return [
                    ...benefits,
                    {
                        ...benefit,
                        beneficiaries
                    }
                ]
            } else {
                return [
                    ...benefits,
                    benefit
                ]
            }
        }, []);
        
        await postToController(dispatch, 'saveBeneficiary', JSON.stringify(beneficiaryToSave));
        
        dispatch({ type: LOADING_SCREEN_HIDE });
        
        dispatch({
            type: UPDATE_LIFE_POLICY_BENEFITS,
            payload: benefits
        });
    }
}

export const updateLifeContact = (contact: any) => {
    return async (dispatch, getState) => {
        
        dispatch({ type: LOADING_SCREEN_SHOW });
        
        try {
            await postToController(dispatch, '/livin/UpdateContact', JSON.stringify(contact));
            
            dispatch({
                type: UPDATE_LIFE_CONTACT,
                payload: contact
            });
            
        } catch (err) {
            logErrorToDatabase("Error updateLifeContact, Error: " + err);
            throw err;
        } finally {
            dispatch({ type: LOADING_SCREEN_HIDE });
        }
    }
}

export const saveLifeBeneficiaries = (benefitId: any, beneficiaries: any) => {
    return async (dispatch, getState) => {
        beneficiaries = beneficiaries.map((beneficiary) => {
            return {
                ...beneficiary,
                percentage: beneficiary.percentage.toString()
            }
        });
        
        dispatch({ type: LOADING_SCREEN_SHOW });
        
        try {
            const benefits = getState().lifePolicy.policy.benefits.reduce((benefits, benefit) => {
                if (benefit.id === benefitId) {
                    return [
                        ...benefits,
                        {
                            ...benefit,
                            beneficiaries
                        }
                    ]
                } else {
                    return [
                        ...benefits,
                        benefit
                    ]
                }
            }, []);
            
            await postToController(dispatch, '/livin/saveBeneficiaries', JSON.stringify({
                beneficiaries,
                benefitId
            }));
            
            dispatch({
                type: UPDATE_LIFE_POLICY_BENEFITS,
                payload: benefits
            });
            
            
        } catch (err) {
            logErrorToDatabase("Error saveLifeBeneficiaries, Error: " + err);
            throw err;
        } finally {
            dispatch({ type: LOADING_SCREEN_HIDE });
        }
    }
}

export const getLifeBankingDetailsPage = (count: number = 8, skip: number = 0, more?: boolean) => {
    return async (dispatch, getState) => {
        // dispatch({ type: LOADING_SCREEN_SHOW });

        Promise.all([dispatch(getLifeBankingDetails()), dispatch(getLifeCollections(count, skip, more))])
            .then(async() => {
                // dispatch({ type: LOADING_SCREEN_HIDE });
            }, (err) => {
                // dispatch({ type: LOADING_SCREEN_HIDE });
            });
    }
}

export const setCollectionToSchedule = (id) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_COLLECTION_TO_SCHEDULE,
            payload: id,
        });
    }
}

export const getSpecialDebitDays = () => {
    return async (dispatch, getState) => {
        try {
            dispatch({
                type: UPDATE_LIFE_ENTITY_METADATA,
                payload: {
                    ...getState().lifePolicy.metadata,
                    specialDebitDays: { loading: true }
                },
            });
            
            const specialDebitDaysResponse = await postToController(dispatch, '/livin/GetSpecialDebitDays', null);
            
            if (specialDebitDaysResponse && specialDebitDaysResponse !== 'Failure') {
                dispatch({
                    type: SET_LIFE_SPECIAL_DEBIT_DAYS,
                    payload: specialDebitDaysResponse.days,
                })
            }
        } finally {
            dispatch({
                type: UPDATE_LIFE_ENTITY_METADATA,
                payload: {
                    ...getState().lifePolicy.metadata,
                    specialDebitDays: { loading: false }
                },
            });
        }
    }
}

export const getLifeBankingDetails = () => {
    return async (dispatch, getState) => {
        try {
            
            dispatch({
                type: UPDATE_LIFE_ENTITY_METADATA,
                payload: { bankingDetails: { loading: true } },
            });
            
            const bankingDetailsResponse = await postToController(dispatch, '/livin/GetBankingDetails', null);

            const debitOrderDueDate = bankingDetailsResponse.debitOrderDueDate;
            const monthsActive = bankingDetailsResponse.monthsActive;
            const startDate = bankingDetailsResponse.policyStartDate;
            const nextDebitOrderDate = bankingDetailsResponse.nextDebitOrderDate;
            const when = bankingDetailsResponse.when;
            
            if (bankingDetailsResponse && bankingDetailsResponse !== 'Failure') {
                dispatch({
                    type: SET_LIFE_BANKING_DETAILS,
                    payload: bankingDetailsResponse,
                })

                dispatch({
                    type: SET_LIFE_POLICY,
                    payload: { debitOrderDueDate, monthsActive, startDate, nextDebitOrderDate, when },
                })
            }
        } catch (err) {
            logErrorToDatabase("Error getLifeBankingDetails, Error: " + err);
        } finally {
            dispatch({
                type: UPDATE_LIFE_ENTITY_METADATA,
                payload: { bankingDetails: { loading: false } },
            });
        }
    }
}

export const getLifeCollections = (count: number = 8, skip: number = 0, more?: boolean) => {
    return async (dispatch, getState) => {
        try {

            dispatch({
                type: UPDATE_LIFE_ENTITY_METADATA,
                payload: { collection: { loading: true } },
            });

            const lifePolicyCollections = await postToController(dispatch, `/livin/GetPolicyCollections?count=${count}&skip=${skip}`, null);

            dispatch({
                type: UPDATE_LIFE_ENTITY_METADATA,
                payload: { collection: { loading: false } },
            });

            if (lifePolicyCollections && lifePolicyCollections !== 'Failure') {

                if (more === true) {
                    dispatch({
                        type: ADD_LIFE_COLLECTIONS,
                        payload: lifePolicyCollections,
                    })
                } else {
                    dispatch({
                        type: SET_LIFE_COLLECTIONS,
                        payload: lifePolicyCollections,
                    })
                }
                return lifePolicyCollections.length;

            }
        } catch (err) {
            logErrorToDatabase("Error getLifeCollections, Error: " + err);
            
            dispatch({
                type: UPDATE_LIFE_ENTITY_METADATA,
                payload: { collection: { loading: false } },
            });
        }
    }
}

export const requestDebicheckMandate = (authType) => {
    return async (dispatch, getState) => {
        try {
            dispatch({
                type: UPDATE_LIFE_ENTITY_METADATA,
                payload: { debicheck: { status: 'saving' } },
            });

            const response = await postToController(dispatch, '/livin/BankingRequestDebicheckMandate', JSON.stringify({
                authenticationType: authType
            }), true);

            dispatch({
                type: UPDATE_LIFE_ENTITY_METADATA,
                payload: { debicheck: { status: 'success' } },
            });

            dispatch({
                type: UPDATE_LIFE_ENTITY_METADATA,
                payload: { bankingDetails: { new: true } },
            });

            dispatch(getLifeBankingDetails());
            dispatch(getLifePolicyDetails("", false));
        } catch (err) {
            logErrorToDatabase("Error requestDebicheckMandate, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        }
    }
};

export const avsValidateBankingDetails = (bankingDetails) => {
    return async (dispatch, getState) => {
        try {
            dispatch({
                type: UPDATE_LIFE_ENTITY_METADATA,
                payload: { bankingDetails: { avsStatus: 'validating' } },
            });

            let route = 'LifeSavePremiumPayerBankingDetails';
            let body: any = {
                bankingDetails: {
                    accountNumber: bankingDetails.accountNumber,
                    accountType: bankingDetails.accountType,
                    bankName: bankingDetails.bankName,
                    branchCode: bankingDetails.branchCode,
                    debitOrderDate: bankingDetails.debitOrderDate,
                },
                debitOrderDueDate: bankingDetails.debitOrderDate
            };

            if (bankingDetails.premiumPayerType === 'Someone else') {
                body = {
                    ...body,
                    mode: 'alt',
                    premiumPayer: {
                        salutation: bankingDetails.title,
                        firstName: bankingDetails.name,
                        lastName: bankingDetails.surname,
                        idNumber: bankingDetails.idNumber,
                        relation: bankingDetails.relationship,
                        email1: bankingDetails.email,
                        phoneMobile: bankingDetails.phoneNumber,
                        notes: bankingDetails.notes,
                    }
                }
            }

            dispatch({
                type: SET_LIFE_BANKING_DETAILS,
                payload: bankingDetails
            });

            dispatch({
                type: UPDATE_LIFE_PREMIUM_PAYER,
                payload: {
                    ...body['alternatePayerDetails']
                }
            });
            
            const response = await postToController(dispatch, route, JSON.stringify({
                ...body
            }), true);

            if (response && response !== 'Failure' && response.success !== false) {
                dispatch({
                    type: UPDATE_LIFE_ENTITY_METADATA,
                    payload: { bankingDetails: { avsStatus: 'valid' } },
                });

                dispatch(getLifePolicyDetails("", false));
            } else {

                let errMessage;
                let errMessageString;
                try {
                    errMessage = JSON.parse(response.message);
                    errMessageString = errMessage['Message']['Message'];
                } catch (e) {
                    errMessage = response.message;
                }
                if (typeof errMessageString !== 'string') {
                    errMessageString = JSON.stringify(errMessageString);
                }
                dispatch({
                    type: UPDATE_LIFE_ENTITY_METADATA,
                    payload: { bankingDetails: { error: errMessageString, success: false, avsStatus: 'invalid' } },
                });
            }
        } catch (err) {
            logErrorToDatabase("Error avsValidateBankingDetails, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        }
    };
};

export const saveBankingDetails = (bankingDetails) => {
    return async (dispatch, getState) => {
        try {

            dispatch({
                type: UPDATE_LIFE_ENTITY_METADATA,
                payload: { bankingDetails: { saving: true, error: null } },
            });

            const response = await postToController(dispatch, `/livin/UpdatePremiumPayerBankingDetails`, JSON.stringify({
                ...bankingDetails
            }), true);

            let errMessage;
            try {
                errMessage = JSON.parse(response.message);
            } catch (e) {
                errMessage = response.message;
            }
            if (response && response !== 'Failure' && response.success !== false) {
                dispatch({
                    type: SET_LIFE_BANKING_DETAILS,
                    payload: bankingDetails
                });
            } else {
                dispatch({
                    type: UPDATE_LIFE_ENTITY_METADATA,
                    payload: { bankingDetails: { error: errMessage, success: false } },
                });
            }
        } catch (err) {
            logErrorToDatabase("Error getLifeCollections, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        } finally {
            dispatch({
                type: UPDATE_LIFE_ENTITY_METADATA,
                payload: { bankingDetails: { saving: false } },
            });
        }
    }
}